import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import "../../../assets/sass/components/forms/editable-text.scss"

const EditableText = ({
    editMode = false,
    onChange = console.log,
    component: Component = 'textarea',
    ...props
}) => {
    const ref = useRef();
    const [value, setValue] = useState(props.defaultValue);
    const [rows, setRows] = useState(5);
    const [minRows] = useState(1);
    const [maxRows] = useState(50);

    useEffect(() => {
        if(ref) {
            handleChange(ref.current);
        }
    }, [editMode, ref]);

    const handleChange = (comp) => {
        const textareaLineHeight = 18;
        const inputValue = comp.value;

        const previousRows = comp.rows;
        comp.rows = minRows; // reset number of rows in textarea 

        const currentRows = ~~((comp.scrollHeight - 12) / textareaLineHeight);

        if (currentRows === previousRows) {
            comp.rows = currentRows;
        }

        if (currentRows >= maxRows) {
            comp.rows = maxRows;
            comp.scrollTop = comp.scrollHeight;
        }

        setRows(currentRows < maxRows ? currentRows : maxRows);
        setValue(inputValue);
        onChange(inputValue);
    };

    return (
        <div className={classNames("editable-text", editMode ? "edit-mode-open" : "edit-mode-close")}>
            <Component
                ref={ref}
                className="editable-text-input"
                rows={rows}
                value={value}
                onChange={e => handleChange(e.target)}
                disabled={!editMode}
                {...props}
            />
        </div>
    )
}

EditableText.propTypes = {
    editMode: PropTypes.bool,
    onChange: PropTypes.func,
    component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ])
}

export default EditableText
